import React from 'react'
import styles from './styles.module.css'
import Toggle from '../../../Toggle'
import Text from '../../../Text'
import { PALETTE } from '../../../../styles/constants'
import { Grow } from '@mui/material'

function BillingCycleToggle({ monthlyText = 'Billed monthly', yearlyText = 'Billed yearly', onToggle, toggled, isLoading }) {
  return (
    <Grow in={!isLoading} timeout={{ enter: 500 }} >
    <div className={styles.billingCycleWrapper}>
      <div className={styles.monthlyBillingText}>
        <Text type="body-short-2">{monthlyText}</Text>
      </div>
      <Toggle
        onToggle={onToggle}
        toggled={toggled}
      />
      <div className={styles.yearlyBillingText}>
        <Text type="body-short-2">{yearlyText}</Text>
        <div className={styles.saveOnYearlyText}>
          <Text type="caption-1" color={PALETTE.blue50}>Save 20%</Text>
        </div>
      </div>
    </div>
    </Grow>
  )
}

export default BillingCycleToggle
